import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getSlateSpacingPixels } from "@faire/retailer-shared/SlateMappings/getSlateSpacingPixels";
import { SDUIOnClickHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { getSlateWebAvatarSize, SDUIAvatarElementRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Avatar/SDUIAvatarElementRenderer";
import { SDUITypographyRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { assignInlineVars } from "@faire/retailer-visitor-shared/lib/tailwindUtils";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { DIMENSION_BY_SIZE } from "@faire/web--source/slate/Avatar/Avatar";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
export var SDUIAvatarTileRenderer = function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData;
    var on_click = tileElement.on_click;
    var _tileElement_avatar_tile;
    var _ref = (_tileElement_avatar_tile = tileElement.avatar_tile) !== null && _tileElement_avatar_tile !== void 0 ? _tileElement_avatar_tile : {}, avatar_element = _ref.avatar_element, avatar_list = _ref.avatar_list, subtitle = _ref.subtitle;
    var avatarList = isNotUndefined(avatar_list) && avatar_list.length > 0 ? avatar_list : [
        avatar_element
    ].filter(isNotUndefined);
    if (avatarList.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(SDUIOnClickHandler, {
        onClickActions: on_click,
        loggingData: loggingData,
        logLegacyClickEvent: true,
        className: "flex w-fit flex-col items-center",
        children: [
            /*#__PURE__*/ _jsx(Row, {
                align: "center",
                children: avatarList.map(function(avatarElement, index) {
                    var _avatarElement_avatar_style, _avatarElement_avatar, _avatarElement_logging_data;
                    var overlapAmount = DIMENSION_BY_SIZE[getSlateWebAvatarSize((_avatarElement_avatar = avatarElement.avatar) === null || _avatarElement_avatar === void 0 ? void 0 : (_avatarElement_avatar_style = _avatarElement_avatar.style) === null || _avatarElement_avatar_style === void 0 ? void 0 : _avatarElement_avatar_style.size)] - getSlateSpacingPixels("R");
                    return /*#__PURE__*/ _jsx(SDUIAvatarElementRenderer, {
                        className: "not-first:ml-(--avatar-overlap-amount)",
                        componentStyle: assignInlineVars(_define_property({}, "--avatar-overlap-amount", "-".concat(overlapAmount, "px"))),
                        avatarElement: avatarElement,
                        loggingData: loggingData
                    }, "".concat(index, "-").concat((_avatarElement_logging_data = avatarElement.logging_data) === null || _avatarElement_logging_data === void 0 ? void 0 : _avatarElement_logging_data.instance_identifier));
                })
            }),
            subtitle ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    }),
                    /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                        textElement: subtitle,
                        loggingData: loggingData
                    })
                ]
            }) : null
        ]
    });
};
